/* eslint-disable */
import { ICommonDropdownOption, RegularButton } from 'pg-ui-library';

export enum Support {
  PAYROLL = 'pay_history',
  BENEFITS = 'benefits',
  TAX = 'tax_forms',
  hr_profile = 'hr_profile',
  PERSONAL_DETAILS = 'Personal Details',
}

type SubCategoryOption = {
  key: string;
  label: string;
  value: string;
};

// Define the type for support desk submodules with string keys
type SupportDeskSubmodules = {
  [key: string]: SubCategoryOption[];
};

export const supportDeskOptions: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'Payroll',
    value: Support.PAYROLL,
  },
  {
    key: '2',
    label: 'Benefits',
    value: Support.BENEFITS,
  },
  {
    key: '3',
    label: 'Tax',
    value: Support.TAX,
  },
  {
    key: '4',
    label: 'Profile',
    value: Support.hr_profile,
  },
  // {
  //   key: '5',
  //   label: Support.PERSONAL_DETAILS,
  //   value: Support.PERSONAL_DETAILS,
  // },
];

export const supportDeskSubmodules: SupportDeskSubmodules = {
  ['pay_history']: [
    { key: '1', label: 'Address Change', value: 'Address Change' },
    { key: '2', label: 'Bonus/Commissions', value: 'Bonus/Commissions' },
    { key: '3', label: 'Data Management', value: 'Data Management' },
    { key: '4', label: 'Expense Reimbursement', value: 'Expense Reimbursement' },
    { key: '5', label: 'Garnishments', value: 'Garnishments' },
    { key: '6', label: 'Holiday Pay', value: 'Holiday Pay' },
    { key: '7', label: 'Leave Accruals and Balances', value: 'Leave Accruals and Balances' },
    { key: '8', label: 'Overpayments', value: 'Overpayments' },
    { key: '9', label: 'Paid Time Off', value: 'Paid Time Off' },
    { key: '10', label: 'Payroll Deductions', value: 'Payroll Deductions' },
    { key: '11', label: 'Paystatements', value: 'Paystatements' },
    { key: '12', label: 'Refund or Payroll Adjustments', value: 'Refund or Payroll Adjustments' },
    { key: '13', label: 'Salary/Wages', value: 'Salary/Wages' },
    { key: '14', label: 'Severance Pay', value: 'Severance Pay' },
    { key: '15', label: 'Sick Pay', value: 'Sick Pay' },
    { key: '16', label: 'Timesheet/Attendance Records', value: 'Timesheet/Attendance Records' },
    { key: '17', label: 'Underpayments', value: 'Underpayments' },
    { key: '18', label: 'Unused Vacation/Sick Leave Payouts', value: 'Unused Vacation/Sick Leave Payouts' },
  ],
  ['hr_profile']: [
    { key: '1', label: 'Personal Info', value: 'Personal Info' },
    { key: '2', label: 'Address', value: 'Address' },
    { key: '3', label: 'Work Location', value: 'Work Location' },
    { key: '4', label: 'Direct Deposit Change', value: 'Direct Deposit Change' },
    { key: '5', label: 'Mobile Number / Email Address Change', value: 'Mobile Number / Email Address Change' },
    { key: '6', label: 'Tax Form', value: 'Tax Form' },
    { key: '7', label: 'Name Change', value: 'Name Change' },
    { key: '8', label: 'Location / Address Change', value: 'Location / Address Change' },
  ],
  ['benefits']: [
    { key: '1', label: 'New Hire', value: 'NEW HIRE' },
    { key: '2', label: 'Open Enrollment', value: 'Open Enrollment' },
    { key: '3', label: 'Qualifying Life Events', value: 'Qualifying Life Events' },
    { key: '4', label: 'Active', value: 'Active' },
    { key: '5', label: 'Enrollment History', value: 'Enrollment History' },
    { key: '6', label: 'Unemployment', value: 'Unemployment' },
    { key: '7', label: 'Garnishment', value: 'Garnishment' },
    { key: '8', label: 'W2/W4', value: 'W2/W4' },
    { key: '9', label: 'Benefits Eligibility', value: 'Benefits Eligibility' },
    { key: '10', label: 'QLE documents', value: 'QLE documents' },
    { key: '11', label: 'Vendor ID Card information', value: 'Vendor ID Card information' },
    { key: '12', label: 'Leaves and Disability', value: 'Leaves and Disability' },
    { key: '13', label: 'Workers Compensation', value: 'Workers Compensation' },
    { key: '14', label: '401(k) (Empower)', value: '401(k) (Empower)' },
    { key: '15', label: 'Enrollment (New Hires)', value: 'Enrollment (New Hires)' },
    { key: '16', label: '1095/1094', value: '1095/1094' },
    { key: '17', label: 'Address Changes', value: 'Address Changes' },
    { key: '18', label: 'ADA Accommodations', value: 'ADA Accommodations' },
    { key: '19', label: 'Beneficiary Forms', value: 'Beneficiary Forms' },
    { key: '20', label: 'EOI (Evidence of Insurability)', value: 'EOI (Evidence of Insurability)' },
    { key: '21', label: 'ESS Portal', value: 'ESS Portal' },
    { key: '22', label: 'General Questions', value: 'General Questions' },
    { key: '23', label: 'Dependents', value: 'Dependents' },
  ],
  ['tax_forms']: [
    { key: '1', label: 'Tax Exemptions', value: 'Tax Exemptions' },
    { key: '2', label: 'Excess Tax Withheld', value: 'Excess Tax Withheld' },
    { key: '3', label: 'Incorrect Tax Withholding', value: 'Incorrect Tax Withholding' },
    { key: '4', label: 'State Forms', value: 'State Forms' },
    { key: '5', label: 'Tax Filing Status', value: 'Tax Filing Status' },
  ],
};
